module.exports = __webpack_public_path__ + "img/bg_map_01.25f77d8c.jpg";